import React, { Fragment } from "react";
import { Link } from "react-router-dom";

function Bloghome(){

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
    return(
        <Fragment>
         <section id="recent-posts" className="recent-posts sections-bg">
      <div className="container" data-aos="fade-up">

        <div className="section-header">
          <h2>Our Latest Blogs</h2>
          <p></p>
        </div>
        <div className="row gy-4">
           <div className="col-xl-4 col-md-6">
            <article>

              <div className="post-img">
                <img src="assets/img/blog/blog7image.webp" alt="" className="img-fluid" />
              </div>

              <p className="post-category">Security Guard Services </p>

              <h3 className="title">
              <Link to="/blog/reliable-security-guard-services-in-noida-for-businesses" onClick={scrollToTop}>Reliable Security Guard Services in Noida for Businesses</Link>
              </h3>

              <div className="d-flex align-items-center">
                <img src="assets/img/blog/writer-male.png" alt="" className="img-fluid post-author-img flex-shrink-0" />
                <div className="post-meta">
                  <p className="post-author">Richa Kushwaha</p>
                  <p className="post-date">
                    <time dateTime="2026-04-08">April 08, 2026</time>
                  </p>
                </div>
              </div>

            </article>
          </div>
          <div className="col-xl-4 col-md-6">
            <article>

              <div className="post-img">
                <img src="assets/img/blog/blog6image.webp" alt="" className="img-fluid" />
              </div>

              <p className="post-category">commercial cleaning</p>

              <h3 className="title">
              <Link to="/blog/how-to-choose-the-best-commercial-cleaning-service-in-delhi-ncr" onClick={scrollToTop}>How to Choose the Best Commercial Cleaning Service in Delhi NCR?</Link>
              </h3>

              <div className="d-flex align-items-center">
                <img src="assets/img/blog/writer-male.png" alt="" className="img-fluid post-author-img flex-shrink-0" />
                <div className="post-meta">
                  <p className="post-author">Richa Kushwaha</p>
                  <p className="post-date">
                    <time dateTime="2026-03-10">March 10, 2026</time>
                  </p>
                </div>
              </div>

            </article>
          </div>
           <div className="col-xl-4 col-md-6">
            <article>

              <div className="post-img">
                <img src="assets/img/blog/pantryboy.webp" alt="" className="img-fluid" />
              </div>

              <p className="post-category">Pantry Boy Services</p>

              <h3 className="title">
              <Link to="/blog/what-is-pantry-boy-duties-responsibilities" onClick={scrollToTop}>What is a Pantry Boy? Duties, Work, Responsibilities & Office Service Guide?</Link>
              </h3>

              <div className="d-flex align-items-center">
                <img src="assets/img/blog/writer-male.png" alt="" className="img-fluid post-author-img flex-shrink-0" />
                <div className="post-meta">
                  <p className="post-author">Richa Kushwaha</p>
                  <p className="post-date">
                    <time dateTime="2026-02-03">Feb 23, 2026</time>
                  </p>
                </div>
              </div>

            </article>
          </div>
        </div>

      </div>
    </section>
        </Fragment>
    )
}
export default Bloghome;